module.exports = __webpack_public_path__ + "static/media/icon_handball.9cc4e9b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon_handball.png
// module id = 143
// module chunks = 0